const SYS_API_BASE = 'https://api.sys.undercontrol.tech';

export async function getSystemLockedEventIds(driverId) {
  const url = `${SYS_API_BASE}/portal/dotInspectionLock.php?driverId=${driverId}`;
  const response = await fetch(url);
  const result = await response.json();
  return new Set(result.eventIds || []);
}

export function isLocked(event, systemLockedIds) {
  return event.i === true || systemLockedIds.has(event._id);
}

export function findLockedEvent(events, systemLockedIds) {
  return events.find((event) => isLocked(event, systemLockedIds));
}

export function alertLockedEvent(lockedEvent) {
  const date = new Date(lockedEvent.eventTime.timestamp).toLocaleDateString();
  alert(`You tried to move a locked status (DOT/System) by the DOT. Please check the date: ${date}. Please restore the backup or press undo`);
}
